import React from "react";
// Signed-in user context
const UserContext = React.createContext({});

export default UserContext;
